import Topbar from "../../components/Topbar";
import { useCompras } from "./hooks/useCompras";
import AbaItens from "./components/AbaItens";
import AbaNotasFiscais from "./components/AbaNotasFiscais";
import ModalEstoque from "./components/ModalEstoque";
import ModalAlertaVinculo from "./components/ModalAlertaVinculo";

export default function Compras() {
  const dados = useCompras();

  return(
    <>
      <Topbar title="Compras"/>
      <div className="erp-content">
        <div className="flex-row mb-12">
          <button className={"btn btn-secondary"+(dados.aba==="itens"?" aba-ativa":"")} onClick={()=>dados.setAba("itens")}>
            <i className="ti ti-box"/> Itens de Compra
            {dados.gruposNaoVinculados.length>0&&<span style={{marginLeft:6,background:"var(--z-danger-text)",color:"#fff",borderRadius:10,padding:"1px 6px",fontSize:10}}>{dados.gruposNaoVinculados.length}</span>}
          </button>
          <button className={"btn btn-secondary"+(dados.aba==="nfs"?" aba-ativa":"")} onClick={()=>dados.setAba("nfs")}>
            <i className="ti ti-file-invoice"/> Notas Fiscais ({dados.pedidos.length})
          </button>
        </div>

        {dados.aba==="itens" && <AbaItens dados={dados} />}
        {dados.aba==="nfs" && <AbaNotasFiscais dados={dados} />}
      </div>

      <ModalEstoque modalEstoque={dados.modalEstoque} setModalEstoque={dados.setModalEstoque}
        estoqueForm={dados.estoqueForm} setEstoqueForm={dados.setEstoqueForm} movimentarEstoque={dados.movimentarEstoque}/>

      <ModalAlertaVinculo alertaVinculo={dados.alertaVinculo} setAlertaVinculo={dados.setAlertaVinculo}
        confirmarPreco={dados.confirmarPreco}/>
    </>
  );
}
